
import ns from 'ns';
import $ from 'jquery';
import Promise from 'Promise';

const cached = {};

export default {
	/**
	 * Requests data from the database by POSTing to
	 * the Api service in /api/
	 * 
	 * Calls that need to talk to the UdeM API are not using Api.request(), they have
	 * their own functions.
	 * 
	 * @param {String} fcn - Route / Endpoint of the API. Refer to /api/CursusApi.php
	 * @param {Object} [data] - Data to POST to the server, if any. 
	 * 
	 * @Promise {Object} res - Response from the AJAX call.
	 * 
	 * @return {Promise} 
	 */
	request: (fcn, data) => {
		let mappedData;
		if (!ns.isLocal && data) {
			mappedData = {
				tx_qmapiservice_userinfos: data,
			};
		} else {
			mappedData = data;
		}

		const post = {
			url: `${ns.api}/${fcn}`,
			method: 'POST',
			data: mappedData,
			dataType: 'json',
		};

		return Promise.resolve($.ajax(post));
	},

	/**
	 * Gets the saved test from the database.
	 * 
	 * @Promise {Object} res - Response from the AJAX call.
	 * 
	 * @return {Promise}
	 */
	getCursus() {
		return Promise.resolve($.ajax('/api/getcursus/'));
	},

	/**
	 * Saves the data to the database.
	 * 
	 * @param {String} data - Serialized JSON Object
	 * 
	 * @Promise {Object} res - Response from the AJAX call.
	 * 
	 * @return {Promise}
	 */
	setCursus(data) {
		const mappedData = {
			tx_qmapiservice_userinfos: {
				data,
				method: 'POST',
			},
		};

		return Promise.resolve($.ajax({
			url: '/api/setcursus/',
			method: 'POST',
			data: mappedData
		}));
	},

	/**
	 * Gets the user information from the database.
	 * 
	 * @Promise {Object} res - Response from the AJAX call.
	 * 
	 * @return {Promise}
	 */
	getUser() {
		return Promise.resolve($.ajax('/api/getuser/'));
	},
};
